import { render } from "./NovaLoja.vue?vue&type=template&id=382f5934"
import script from "./NovaLoja.vue?vue&type=script&lang=js"
export * from "./NovaLoja.vue?vue&type=script&lang=js"
script.render = render

export default script